import { Injectable } from '@angular/core';
import { SERVICE_URLS } from '../enums';
import { BaseService } from './base.service';
import { DataService } from './data.service';

import * as _ from 'lodash';
import { of } from 'rxjs';
// import {of} from 'rxjs/operators';

let TmxLookupJson = [];
@Injectable({
  providedIn: 'root'
})
export class LookupService {
  lookupByType: any;
  lookups: any = {};
  Brancheslookups: any = {};
  constructor(private baseService: BaseService) {
  }

  getAllLookups() {
    let lookups = DataService.get('Lookups')
    if (lookups) {
      return of(lookups); // creates an observable of the object
    }
    return this.baseService.Request(SERVICE_URLS.GET_ALL_LOOKUPS);
  }
  getBranchesLookups() {
    let branches = DataService.get('Branches');
    if (branches) {
      return of(branches); // creates an observable of the object
    }
    return this.baseService.Request(SERVICE_URLS.GET_BRANCHES_LOOKUPS);
  }

  saveLookups(lookupResponse: any) {
    TmxLookupJson = lookupResponse;
    this.groupLookupByType();
    this.LookupById(lookupResponse);
    // console.log(lookupResponse);
  }
  saveBranchesLookups(BrancheslookupResponse: any) {
    this.Brancheslookups = BrancheslookupResponse;
    // console.log(BrancheslookupResponse);
  }
  getLookupByType(LookupType) {
    return this.lookupByType[LookupType];
  }
  groupLookupByType() {
    this.lookupByType = _.groupBy(TmxLookupJson, 'LookupType');
  }



  LookupById<T>(array: Array<T>) {
    for (let i = 0; i < array.length; i++) {
      const key = array[i]['LookupId'];
      this.lookups[key] = array[i];
    }
    return this.lookups as { [key: string]: T };
  }


}
